import { Badge } from 'antd';
import '../styles/StylishDynamicTabs.css';

function normalizeTab(tab, index) {
  if (!tab || typeof tab !== 'object') return null;
  const key   = tab.key   ?? tab.value ?? tab.id ?? String(index);
  const label = tab.label ?? tab.title ?? tab.name ?? tab.tabTitle;
  if (!key || !label) return null;
  return { key: String(key), label: String(label), count: tab.count ?? tab.countValue };
}

export default function StylishDynamicTabs({ tabs = [], activeKey, onChange, className = '' }) {
  const items = tabs.map(normalizeTab).filter(Boolean);
  if (!items.length) return null;

  const selectedKey = items.some((t) => t.key === activeKey) ? activeKey : items[0].key;

  return (
    <div className={`stylish-tabs ${className}`.trim()}>
      {items.map((tab) => {
        const isActive  = tab.key === selectedKey;
        const hasCount  = tab.count != null;

        return (
          <button
            key={tab.key}
            type="button"
            className={`stylish-tabs__item${isActive ? ' stylish-tabs__item--active' : ''}`}
            onClick={() => onChange?.(tab.key)}
          >
            <span className="stylish-tabs__label">{tab.label}</span>
            {hasCount && (
              <Badge
                count={tab.count}
                overflowCount={999}
                className={`stylish-tabs__badge${isActive ? ' stylish-tabs__badge--active' : ''}`}
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
